module.exports = __webpack_public_path__ + "img/briefcase-clock.6e7dfd8f.svg";